export default __webpack_public_path__ + "static/media/tags-1.2d4b4844.svg";